module.exports = __webpack_public_path__ + "img/L1060683-d.7054a508.jpg";